export var SignUpOriginEnum;
(function (SignUpOriginEnum) {
    SignUpOriginEnum["WEB"] = "web";
    SignUpOriginEnum["CLI"] = "cli";
    SignUpOriginEnum["VERCEL"] = "vercel";
})(SignUpOriginEnum || (SignUpOriginEnum = {}));
